// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"MiniSilla_cardContainer__1qX5Z","img":"MiniSilla_img__32Fmb"};